module.exports = __webpack_public_path__ + "img/icon-ab-test.6971326d.svg";